import { CircularProgress, Dialog, DialogContent } from '@mui/material'
import React from 'react'

function LoadingBarDialog({ loading }) {
    return (
        <Dialog open={loading} onClose={() => { }}> <DialogContent><CircularProgress /></DialogContent> </Dialog>
    )
}

export default LoadingBarDialog